import script from "./AuthChoiceButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthChoiceButtons.vue?vue&type=script&lang=ts&setup=true"

import "./AuthChoiceButtons.vue?vue&type=style&index=0&id=17988c4f&scoped=true&lang=scss"

import exportComponent from "/root/chatgpt-admin/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17988c4f"]])

export default __exports__